<template>
    <label v-if="label">{{ label }}{{ label.match(/[:\.\?]$/) ? '' : ':' }}</label>
    <textarea
            v-bind="$attrs"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :maxlength="maxlength"
            :smaller="smaller"
            class="field"
    ></textarea>
</template>

<script>
	export default {
	    name: 'BaseInput',
		props: {
			label: String,
      maxlength: Number|undefined,
      smaller: Boolean|undefined,
			modelValue: [String, Number]
		}
	}
</script>

<style lang="scss" scoped>
    label {
        display: block;
        font-weight: 700;
        margin-bottom: .3em;
        font-size: .9em;
    }

    textarea {
        display: block;
        width: 100%;
        padding: 1.3em;
        outline: 0;
        border: 2px solid var(--colorInputBorder);
        font-family: inherit;
        height: 8.7em;
        resize: vertical;
        background: transparent;
        border-radius: 0;

        &[type=number] {
            display: inline-block;
            width: 8em;
        }

        &[smaller] {
            height: 6.1em;
        }
    }
</style>
